/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-vars */
import moment from 'moment';
import { apiClient, handleResponse } from './axios';

export async function getStudentsCourses(dendreoId) {
  try {
    const response = await apiClient.get(`/dendreo/student/${dendreoId}`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function getTeachersCourses(dendreoId) {
  try {
    const response = await apiClient.get(`/dendreo/teacher/${dendreoId}`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function getCourse(idCreneau, idActionDeFormation) {
  try {
    const response = await apiClient.get(`/dendreo/action/${idCreneau}/${idActionDeFormation}`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function getLearnerPresencesSummary(idActionDeFormation, dendreoId) {
  try {
    const response = await apiClient.get(`/dendreo/adf/${idActionDeFormation}/participants/${dendreoId}/presences`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function sendSignatureEmails(body) {
  try {
    const response = await apiClient.post('/dendreo/signatures', body);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}
export async function downloadParticipantFormationEmargement(idActionDeFormation, idParticipant) {
  try {
    const response = await apiClient.get(`/dendreo/adf/pdf-participant/${idActionDeFormation}/${idParticipant}`,
      {
        responseType: 'blob',
      });
    return response.data;
  } catch (err) {
    return err.response;
  }
}
export async function downloadAdfEmargement(idActionDeFormation) {
  try {
    const response = await apiClient.get(`/dendreo/adf/pdf-adf/${idActionDeFormation}`,
      {
        responseType: 'blob',
      });
    return response.data;
  } catch (err) {
    return err.response;
  }
}
export async function downloadCreneauEmargement(idCreneau, idActionDeFormation) {
  try {
    const response = await apiClient.get(`/dendreo/adf/pdf-creneau/${idCreneau}/${idActionDeFormation}`,
      {
        responseType: 'blob',
      });
    return response.data;
  } catch (err) {
    return err.response;
  }
}
export async function getActionFormationDetails(idActionDeFormation) {
  try {
    const response = await apiClient.get(`/dendreo/adf/${idActionDeFormation}`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function getParticipantActionsFormation(idParticipant) {
  try {
    const response = await apiClient.get(`/dendreo/adf/participant/${idParticipant}`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function getAdfSatisfaction(idActionDeFormation) {
  try {
    const response = await apiClient.get(`/dendreo/adf/${idActionDeFormation}/satisfaction`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}
